<template>
	<div>
		<h3 class="text-center">Cosφ</h3>
		<div id="cosphi-chart" style="height: 500px"></div>
	</div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
	name: "CosPhiLineChart",
	props: ['data'],
	data() {
		return {
			colors: this.$store.state.colors,
		}
	},
	mounted() {

		// create a bar chart with AMCharts 4
		var chart = am4core.create("cosphi-chart", am4charts.XYChart);
		chart.data = this.chartData

		console.log(this.chartData)
		console.log("!")

		// create a category axis
		var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "month";
		categoryAxis.renderer.labels.template.adapter.add("textOutput", (text, target) => {
			return this.monthsNames[parseInt(text) - 1]
		});

		// create a value axis
		chart.yAxes.push(new am4charts.ValueAxis());

		// add a legend
		chart.legend = new am4charts.Legend();

		// set minimum value to 0 for Y axis
		chart.yAxes.getIndex(0).min = 0;
		chart.yAxes.getIndex(0).max = 1;

		// create a series
		const slots = ['f1', 'f2', 'limite']
		slots.forEach((slot, index) => {
			var seriesColor = this.colors[index];
			const data = this.chartData
			const series = chart.series.push(new am4charts.LineSeries());
			series.dataFields.valueY = slot;
			series.dataFields.categoryX = "month";
			series.name = slot.toUpperCase();
			series.data = data;
			//series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
			series.stroke = am4core.color(seriesColor);
		})
	},
	computed: {
		chartData() {
			return this.data.map((e, index) => {
				return {
					month: index + 1,
					f1: e.f1,
					f2: e.f2,
					limite: 0.95
				}
			})
		},
		monthsNames() {
			return this.$store.state.utils.months;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/BillAudit/Charts/CosPhiLineChart.vue